import { Row } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { GiProgression } from "react-icons/gi";

import { Button } from "@/components/ui/button/button";
import { Employee } from "./schema";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const navigate = useNavigate();
  const originData = row.original as Employee;

  return (
    <>
      <Button
        size="icon"
        className="w-5 h-5"
        onClick={() => {
          navigate(
            `/admin/todos/employee-progress/${originData.id}?n=${originData.name}`
          );
        }}
      >
        <GiProgression className="w-3 h-3" />
      </Button>
    </>
  );
}
